import appinsights from '@plugins/appinsights'

export default function (store) {
  store.$appInsights = appinsights
}
